module.exports = __webpack_public_path__ + "img/store-icon.89592b3e.svg";